import Actions from "./LeadsActionTypes";

export const getAllLeads = (params = {}) => {
  return {
    type: Actions.FETCH_ALL_LEADS,
    payload: params,
  };
};
